'use client';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx/lite';
import { useState } from 'react';

export const FaqCard: React.FC<{
  question: React.ReactNode;
  answer: React.ReactNode;
  showDivider?: boolean;
  compact?: boolean;
  className?: string;
}> = ({ question, answer, showDivider = false, compact = false, className }) => {
  const [isShowing, handleShow] = useState(false);
  return (
    <div
      className={clsx(
        'flex w-full flex-col bg-neutral-surface',
        showDivider ? 'border-b border-neutral-600' : 'rounded-lg',
        compact ? 'py-5' : 'p-5',
        className,
      )}
    >
      <div className="faq flex flex-col gap-6">
        <button aria-label={isShowing ? 'Nascondi' : 'Mostra'} onClick={() => handleShow(!isShowing)}>
          <div className="text-neutral-dark inline-flex w-full items-center justify-between text-left text-lg">
            {question}
            <span className="ml-4 lg:ml-8">
              {isShowing ? <ChevronUpIcon className="h-6 w-6 text-secondary" /> : <ChevronDownIcon className="h-6 w-6 text-secondary" />}
            </span>
          </div>
        </button>
        <div className={clsx('nojs_flex flex flex-col gap-y-6 text-base text-neutral-lighter', isShowing ? 'visible' : 'hidden')}>
          {answer}
        </div>
      </div>
    </div>
  );
};
